import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { Lightning, Wrench, PipeWrench, Plant, Toolbox, ArrowRight } from "@phosphor-icons/react";

export const CATEGORIES = [
  {
    id: "electrician",
    label: "Electrician",
    tagline: "Wiring, panels, lighting & rewires",
    icon: Lightning,
    image:
      "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBob21lfGVufDB8fHx8MTc4NTg3MjMxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "plumber",
    label: "Plumber",
    tagline: "Leaks, drains, boilers & installs",
    icon: PipeWrench,
    image:
      "https://images.pexels.com/photos/7220892/pexels-photo-7220892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "handyman",
    label: "Handyman",
    tagline: "Repairs, mounting, assembly & fixes",
    icon: Wrench,
    image:
      "https://images.unsplash.com/photo-1645651964715-d200ce0939cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxoYW5keW1hbiUyMHdvcmtpbmclMjB0b29sc3xlbnwwfHx8fDE3ODU4NzIzMTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gardening",
    label: "Gardening Services",
    tagline: "Lawns, hedges, landscaping & upkeep",
    icon: Plant,
    image:
      "https://images.unsplash.com/photo-1719324924230-63781a3f18b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxnYXJkZW5lciUyMGxhbmRzY2FwZSUyMGJhY2t5YXJkfGVufDB8fHx8MTc4NTg3MjMxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "general",
    label: "General",
    tagline: "Something else? Describe your job",
    icon: Toolbox,
    image:
      "https://images.unsplash.com/photo-1645651964715-d200ce0939cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxoYW5keW1hbiUyMHdvcmtpbmclMjB0b29sc3xlbnwwfHx8fDE3ODU4NzIzMTF8MA&ixlib=rb-4.1.0&q=85",
  },
];

const ClientCategoriesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFFFF]" data-testid="client-categories-page">
      <Header />
      <main className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
        <div className="max-w-2xl animate-fade-up">
          <p className="text-sm font-semibold uppercase tracking-widest text-[#C65D47]">
            Step 02 / 03 — What do you need?
          </p>
          <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-[#0A0F0D] sm:text-5xl lg:text-6xl">
            Pick a service.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-[#5C605E]">
            Choose the trade that best fits your job — we&apos;ll match you with local pros in that category next.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((cat, i) => {
            const Icon = cat.icon;
            return (
              <button
                key={cat.id}
                onClick={() => navigate(`/client/job/new?category=${cat.id}`)}
                data-testid={`category-${cat.id}-card`}
                className="group relative overflow-hidden rounded-md border border-[#E5E2DB] bg-white text-left transition-all duration-300 hover:border-[#0A0F0D] hover:shadow-brutal"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="relative h-48 w-full overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.label}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F0D]/60 to-transparent" />
                  <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-md bg-[#FFFFFF]">
                    <Icon size={22} weight="duotone" color="#0A0F0D" />
                  </div>
                </div>
                <div className="flex items-center justify-between p-6">
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight text-[#0A0F0D]">
                      {cat.label}
                    </h3>
                    <p className="mt-1 text-sm text-[#5C605E]">{cat.tagline}</p>
                  </div>
                  <ArrowRight
                    size={20}
                    weight="bold"
                    className="text-[#0A0F0D] transition-transform group-hover:translate-x-1 group-hover:text-[#C65D47]"
                  />
                </div>
              </button>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default ClientCategoriesPage;
